<template>
    <div class="z-40">
        <audio controls ref="audioElement" class="hidden">
            <source :src="url" type="audio/mpeg">
            Your browser does not support the audio element.
        </audio>
        <div class=" w-full h-auto mx-auto">
            <div class="relative w-full">
                <CloseButton class="absolute !-top-1 !-right-1" @close="close()"/>
                <div class="flex w-full justify-center text-center">
                    <BodyInfo :song="song" :artist="artist" />
                </div>
                <div class="flex flex-col items-center w-full justify-center text-center">
                    <AudioRange @move="onMove" :time="currentTime" />
                    <div class="flex flex-row items-center justify-between text-xs text-gray-500 w-full text-center pl-2 pr-2">
                    <span>{{ formatTime }}</span> <span>{{ formatDuration }}</span>
                    </div>
                </div>
                <div class="flex justify-center w-full z-20">
                    <PlayerControls :isPaused="isPaused" @play="playSong" @previous="previousSong" @next="nextSong" />
                </div>
            </div>
        </div>
        <!-- <div class="w-full h-[150px] md:h-auto md:w-[302px] border mt-8 mx-auto bg-white rounded shadow-[0_10px_20px_-5px_rgba(0,0,0,0.19),0_6px_6px_-10px_rgba(0,0,0,0.23)]">
            <div class="relative w-full md:w-[302px]">
                <CloseButton @close="close()"/>
                <div class="absolute block md:hidden w-full z-20">
                    <AudioRange  @move="onMove" :time="currentTime" />
                </div>
                
                <div class="relative md:w-[300px] md:h-auto md:max-h-[300px] transition-all hidden md:block" ref="cover">
                    <Transition>
                        <img v-if="image" :src="image" class="hidden md:block opacity-75 max-w-full rounded" alt="Album cover" />
                    </Transition>
                    <div class="absolute hidden md:block -bottom-4 w-full">
                        <AudioRange  @move="onMove" :time="currentTime" />
                    </div>
                </div>
                <div class="pt-6 pb-5 text-center relative">
                  <BodyInfo :song="song" :artist="artist" songClass="truncate ..." />
                </div>
                <div class="relative bottom-2 h-[70px]">
                    <PlayerControls :isPaused="isPaused" @play="playSong" @previous="previousSong" @next="nextSong" />
                </div>
            </div>
        </div> -->
    </div>
</template>
<script setup>
import {defineProps, onMounted, onUnmounted, ref, watch, defineEmits, computed} from 'vue'
import { appEvents } from '@/store/app.events';
//import songService from '../service/song.service';
import PlayerControls from './common/elements/PlayerControls.vue';
import BodyInfo from './common/BodyInfo.vue';

const props = defineProps({
  url: {
    type: String
  },
  metadata: {
    type: Object
  },
  startTime: {
    type: Number,
    default: 0
  }
});
const url = ref(props.url);
const metadata = ref(props.metadata)
const audioElement = ref(null);
const currentTime = ref(0)
const duration = ref(0);
const isPaused = ref(true);
const currentTimeSeconds = ref(0);
// const media = ref(null);

const emits = defineEmits(['close', 'next', 'previous'])

const song = computed(() => {
  if (metadata.value && metadata.value.data && metadata.value.data.title) {
    return metadata.value.data.title;
  } else {
    return "-";
  }
});
const artist = computed(() => {
  return metadata.value?.data?.artist?.name || (typeof metadata.value?.data?.artist === 'string' ? metadata.value.data.artist : '-');
});

const pauseAudio = () => {
    if (audioElement.value && !audioElement.value.paused) {
        audioElement.value.pause();
        isPaused.value = true;
    }
}

onMounted( () => {
    url.value = props.url;
    metadata.value = props.metadata;
    
    audioElement.value.onloadedmetadata = () => {
        duration.value = audioElement.value.duration
        if (props.startTime > 0) {
            audioElement.value.currentTime = props.startTime;
            audioElement.value.play();
            isPaused.value = false;
            appEvents.emit('pause-side-panel-player');
        }
    }
    audioElement.value.ontimeupdate = () => {
        onDurationChange();
    }
    audioElement.value.onended = () => {
        isPaused.value = true;
        audioElement.value.pause()
        audioElement.value.currentTime = 0;
    }
    appEvents.on('pause-main-player', pauseAudio);
    //lookingForCover();
})
onUnmounted(() => {
    appEvents.off('pause-main-player', pauseAudio);
})
watch(() => props.startTime, (newVal) => {
    if (audioElement.value && newVal !== undefined) {
        audioElement.value.currentTime = newVal;
        if (newVal > 0) {
            audioElement.value.play();
            isPaused.value = false;
            appEvents.emit('pause-side-panel-player');
        }
    }
});
watch( () => props.url, () => {
    isPaused.value = true;
    audioElement.value.pause()
    audioElement.value.currentTime = props.startTime || 0;
    url.value = props.url;
    //lookingForCover();
});
watch( () => props.metadata, () => {
    metadata.value = props.metadata;
})

const onMove = (e) => {
    audioElement.value.currentTime = duration.value*(e.percentage/100);
}

const onDurationChange = () => {
    if (audioElement.value) {
        currentTime.value = (audioElement.value.currentTime/duration.value)*100;
        currentTimeSeconds.value = audioElement.value.currentTime;
    } else {
        currentTime.value = 0;
    }
}
const formatTime = computed(() => {
  const minutes = Math.floor((currentTimeSeconds.value % 3600) / 60);
  const seconds = Math.floor(currentTimeSeconds.value % 60);

  const currentString = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return currentString;
})

const formatDuration = computed(() => {
  const minutes = Math.floor((duration.value % 3600) / 60);
  const seconds = Math.floor(duration.value % 60);
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
})

const nextSong = () => {
  emits('next')
}
const previousSong = () => {
  emits('previous')
}
const playSong = () => {
    if (audioElement.value){
        if (!audioElement.value.paused) {
            audioElement.value.pause();
            isPaused.value = true;
        } else {
            audioElement.value.play();
            isPaused.value = false;
            appEvents.emit('pause-side-panel-player');
        }
    }
}

// const lookingForCover = async () => {
//     if (!metadata.value || !metadata.value.data.media){
//         media.value = await songService.fetchMedia(metadata.value.song).then( async (response) => {
//             media.value = await response.json();
//             if (media.value){
//                 for(let m of media.value){
//                   if (m.images){
//                     if(m.images[1]){
//                       image.value = m.images[1].url ?? m.images[1]
//                     }else {
//                       image.value = m.images[0].url ?? m.images[0]
//                     }
//                   }
//                 }
//             }
//         }).catch( () => {
//             media.value = null;
//         });
//     } else {
//         media.value = metadata.value.data.media;
//         if (media.value){
//             for(let m of media.value){
//                 if (m.images){
//                   if(m.images[1]){
//                     image.value = m.images[1].url ?? m.images[1]
//                   }else {
//                     image.value = m.images[0].url ?? m.images[0]
//                   }
//                 }
//             }
//         }
//     }
// }
const close = () => {
    emits('close')
}
</script>
